<div class="quantity-control-group">
  <ng-content></ng-content>
  <ng-container *ngIf="(min > 0 && value >= min) || min === 0">
    <button
      (click)="handleDecreaseClick()"
      [disabled]="decreaseDisabled"
      class="btn btn-outline btn-circle"
      [ngClass]="{
        'btn-circle-sm': size === 'sm'
      }"
    >
      -
    </button>
    <span class="quantity-control-value">{{ value }}</span>
  </ng-container>

  <ng-container *ngIf="max !== null && max === value">
    <span class="btn btn-circle btn-circle-sm btn-primary btn-checked"> </span>
  </ng-container>

  <ng-container *ngIf="max === null || max !== value">
    <button
      (click)="handleIncreaseClick()"
      [disabled]="disabled"
      class="btn btn-tertiary btn-circle"
      [ngClass]="{
        'btn-circle-sm': size === 'sm'
      }"
    >
      <plys-button-label [loading]="displayLoading || buttonRecentlyClicked"> + </plys-button-label>
    </button>
  </ng-container>
</div>
